import React from 'react';
import './Spinner.css';

export const Spinner: React.FC = () => {
  return (
    <div className="spinner-container">
      <div className="spinner">
        <div className="spinner-inner" />
      </div>
    </div>
  );
}; 